export default {
  title: "مدیریت مدل‌ها",
  addNew: "افزودن مدل جدید",
  brands: "برندها",
  name: "نام مدل",
  SelectBrand: "یک برند انتخاب کنید",
  editModel: "ویرایش مدل {{name}}",
};
